import { CfFlowScreen } from './api/cloudflareFlowApi';

export type CfScreenTrail = {
  readonly visited: readonly CfFlowScreen[];
  readonly stepsBack: number;
};

export const EMPTY_SCREEN_TRAIL: CfScreenTrail = { visited: [], stepsBack: 0 };

const SCREENS_THE_CUSTOMER_ACTS_ON: readonly CfFlowScreen[] = ['cf_account', 'token', 'reconnect', 'nameservers'];

const viewOf = (screen: CfFlowScreen): CfFlowScreen => (screen === 'reconnect' ? 'token' : screen);

export const arriveAt = (trail: CfScreenTrail, screen: CfFlowScreen): CfScreenTrail => {
  const actedOn = trail.visited.filter((visited) => SCREENS_THE_CUSTOMER_ACTS_ON.includes(visited));
  const earlier = actedOn.findIndex((visited) => viewOf(visited) === viewOf(screen));
  const before = earlier === -1 ? actedOn : actedOn.slice(0, earlier);

  return { visited: [...before, screen], stepsBack: 0 };
};

export const latestArrival = (trail: CfScreenTrail): CfFlowScreen | undefined =>
  trail.visited[trail.visited.length - 1];

export const canStepBack = (trail: CfScreenTrail): boolean => trail.stepsBack < trail.visited.length - 1;

export const stepBack = (trail: CfScreenTrail): CfScreenTrail =>
  canStepBack(trail) ? { ...trail, stepsBack: trail.stepsBack + 1 } : trail;

export const stepForward = (trail: CfScreenTrail): CfScreenTrail => ({
  ...trail,
  stepsBack: Math.max(0, trail.stepsBack - 1),
});

export const screenOnDisplay = (trail: CfScreenTrail): CfFlowScreen | undefined =>
  trail.visited[trail.visited.length - 1 - trail.stepsBack];
